import React from "react";

interface PageShellProps {
    children: React.ReactNode;
    className?: string;
}

export default function PageShell({ children, className = "" }: PageShellProps) {
    return (
        <div className={`relative w-full min-h-screen bg-[#EAE8E4] text-[#2C2C2C] selection:bg-[#2C2C2C] selection:text-[#EAE8E4] overflow-x-hidden ${className}`}>
            {children}
        </div>
    );
}
